<template>
    <div>
        <dx-grid
            url="vmForms"
            :columns="columns"
            :title="title"
            ref="grid"
            :actions="actions"
            :onRowClicked="onRowClicked"
            navigationPath="onRowClicked"
            navigationField="onRowClicked"
        ></dx-grid>
        <v-dialog v-model="approveDialog" max-width="490">
            <v-card class="pa-3">
                <v-card-title class="pl-0 py-0 headline mb-2"
                    >VM Form</v-card-title
                >

                <!-- <v-btn
                    v-if="clickedRow && clickedRow.documentURL"
                    small
                    class="mb-3"
                    @click="downloadDocument()"
                    style="height: 35px;"
                >
                    <v-icon color="red" left dark>mdi-file-pdf</v-icon>
                    <span class="mr-2">Kollel Application</span>
                    <v-icon right>mdi-download</v-icon>
                </v-btn> -->

                <v-layout row>
                    <v-btn
                        class="ml-0"
                        color="success"
                        small
                        @click="editApplication"
                        >Edit Form</v-btn
                    >
                    <v-btn
                        class="ml-2"
                        color="danger"
                        dark
                        small
                        @click="openDeleteFormDialog"
                        >Delete</v-btn
                    >
                    <v-spacer></v-spacer>

                    <v-btn
                        class=""
                        color="warning"
                        dark
                        small
                        @click="openApproveTemporaryDialog"
                        >Approve Temporary</v-btn
                    >
                </v-layout>

                <div
                    class="pa-2"
                    style="overflow-y: auto; height: 400px; border: 2px solid #4caf50"
                >
                    <div
                        class="layout row mb-2 pa-0 mx-0"
                        v-for="prop in getRowProperties()"
                    >
                        <div class="font-weight-medium mr-1 width-200">
                            {{ prop.name }}:
                        </div>
                        <div>{{ prop.value }}</div>
                    </div>
                </div>

                <!-- <v-textarea
                    v-model="note"
                    label="Note"
                    class="mt-3"
                    rows="2"
                    outline
                    hide-details
                ></v-textarea>
                <v-select
                    v-if="allowChangingStatus()"
                    v-model="status"
                    label="Status"
                    class="mt-2"
                    :items="[
                        'REJECTED',
                        'DELETED',
                        'APPROVED FULL KOLLEL',
                        'APPROVED KOLLEL WITH SIDE INCOME',
                    ]"
                    hide-details
                ></v-select>
                <v-textarea
                    v-if="allowChangingStatus() && status == 'REJECTED'"
                    v-model="rejectedReason"
                    class="mt-2"
                    rows="2"
                    label="Rejected Reason"
                    outline
                    hide-details
                ></v-textarea>
                <v-textarea
                    v-if="allowChangingStatus() && status == 'DELETED'"
                    v-model="deletedReason"
                    class="mt-2"
                    rows="2"
                    label="Deleted Reason"
                    outline
                    hide-details
                ></v-textarea> -->
                <v-card-actions class="mr-0 mt-2">
                    <v-spacer></v-spacer>
                    <v-btn dark color="default" @click="approveDialog = false"
                        >Close</v-btn
                    >
                    <!-- <v-btn color="success" :loading="processing" @click="save"
                        >Save</v-btn
                    > -->
                </v-card-actions>
            </v-card>
        </v-dialog>
        <v-dialog persistent v-model="deleteFormDialog" max-width="400">
            <v-card class="pa-3">
                <v-card-title class="headline pl-0 pt-0"
                    >Are you sure?</v-card-title
                >
                <div class="font-weight-regular">
                    The VM Form will be deleted
                </div>
                <v-card-actions class="mr-0 mt-3">
                    <v-spacer></v-spacer>
                    <v-btn
                        color="default"
                        dark
                        @click="deleteFormDialog = false"
                        >Cancel</v-btn
                    >
                    <v-btn
                        :loading="processing"
                        color="success"
                        @click="deleteForm"
                    >
                        Delete Form
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <v-dialog persistent v-model="approveTemporaryDialog" max-width="400">
            <v-card class="pa-3">
                <v-card-title class="headline pl-0 py-0"
                    >Approve Temporary</v-card-title
                >
                <v-checkbox
                    v-model="wifeNoSmartphone"
                    color="success"
                    label="מיר טוען באשטעטיגען אז די 'מאמע' פארמאגט נישט קיין סמארטפאון אפילו מיט א פילטער נאר א פשוטע בעיסק פאון
"
                ></v-checkbox>
                <v-card-actions class="mr-0 mt-2 pb-0">
                    <v-spacer></v-spacer>
                    <v-btn
                        color="default"
                        dark
                        @click="approveTemporaryDialog = false"
                        >Cancel</v-btn
                    >
                    <v-btn
                        :loading="processing"
                        color="success"
                        @click="quickSave"
                    >
                        Save
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </div>
</template>

<script>
import moment from "moment";
import { toTitleCase, except } from "../../utils/helpers.js";

export default {
    data: () => ({
        title: "VM Forms",

        note: "",
        status: "",
        rejectedReason: "",
        deletedReason: "",
        approveDialog: false,
        processing: false,
        deleteFormDialog: false,
        clickedRow: "",

        wifeNoSmartphone: false,

        approveTemporaryDialog: false,

        actions: [],

        columns: [
            // {
            //     field: "status",
            //     isIcon: true,
            //     template: "icon",
            //     alignment: "center",
            //     visible: true,
            //     allowFiltering: false,
            //     allowHeaderFiltering: false,
            //     allowHiding: false,
            //     allowSearch: false,
            //     cssClass: "width-25",
            //     icon: (value) => {
            //         if (!value) return "mdi-flag-outline";

            //         switch (value.trim()) {
            //             case "SUBMITTED":
            //                 return "mdi-flag-outline";
            //             case "REJECTED":
            //                 return "mdi-alert-circle";
            //             case "APPROVED":
            //             case "APPROVED FULL KOLLEL":
            //             case "APPROVED KOLLEL WITH SIDE INCOME":
            //                 return "mdi-check-circle";
            //             default:
            //                 return "mdi-flag-outline";
            //         }
            //     },
            //     iconColor: (value) => {
            //         if (!value) return "#fdb400";

            //         switch (value.trim()) {
            //             case "UPLOADED":
            //                 return "#aeb8bf";
            //             case "SUBMITTED":
            //                 return "#fdb400";
            //             case "REJECTED":
            //                 return "#f35123";
            //             case "APPROVED":
            //             case "APPROVED FULL KOLLEL":
            //             case "APPROVED KOLLEL WITH SIDE INCOME":
            //                 return "success";
            //             default:
            //                 return "#fdb400";
            //         }
            //     },
            // },
            {
                label: "Name",
                field: "name",
                visible: true,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                field: "accountID",
                label: "Account ID",
                link: "Account View",
                format: "",
                template: "link-cell-template",
                visible: true,
                filterType: "",
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Date",
                field: "date",
                type: "date",
                format: "MM/dd/yyyy hh:mm:ss a",
                visible: true,
                sortOrder: "desc",
                sortIndex: 0,
                filterValues: [],
                filterValue: new Date(
                    moment()
                        .subtract(1, "month")
                        .add(1, "day"),
                ),
                selectedFilterOperation: ">=",
            },
            {
                label: "Source",
                field: "source",
                visible: true,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Updated By",
                field: "updatedBy",
                visible: true,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Updated At",
                field: "updatedAt",
                type: "date",
                format: "MM/dd/yyyy hh:mm:ss a",
                visible: true,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                field: "kids",
                label: "Kids",
                format: "",
                type: "number",
                visible: true,
                filterType: "",
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                field: "applyingKids",
                label: "Applying Kids",
                format: "",
                visible: true,
                type: "number",
                filterType: "",
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                field: "vmStatus",
                label: "VM Status",
                visible: true,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Address",
                field: "address",
                format: "",
                visible: true,
                filterType: "",
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "HomePhone",
                field: "homePhone",
                format: "",
                visible: true,
                filterType: "",
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Husband Cell 1",
                field: "husbandCell1",
                format: "",
                visible: true,
                filterType: "",
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Husband Cell 2",
                field: "husbandCell2",
                format: "",
                visible: true,
                filterType: "",
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Other Cell",
                field: "otherCell",
                format: "",
                visible: true,
                filterType: "",
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Wife Cell",
                field: "wifeCell",
                format: "",
                visible: true,
                filterType: "",
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Name Of Workplace",
                field: "nameOfWorkplace",
                format: "",
                visible: true,
                filterType: "",
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Work Address",
                field: "workAddress",
                format: "",
                visible: true,
                filterType: "",
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Work Phone",
                field: "workPhone",
                format: "",
                visible: true,
                filterType: "",
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Email",
                field: "email",
                format: "",
                visible: true,
                filterType: "",
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Work Filter",
                field: "workFilter",
                format: "",
                visible: true,
                filterType: "",
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Business Type",
                field: "businessType",
                format: "",
                visible: true,
                filterType: "",
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Boss",
                field: "boss",
                format: "",
                visible: true,
                filterType: "",
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Android Count",
                field: "androidCount",
                format: "",
                type: "number",
                visible: true,
                filterType: "",
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "IPhone Count",
                field: "iPhoneCount",
                type: "number",
                visible: true,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Blackberry Count",
                field: "blackberryCount",
                type: "number",
                visible: true,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Tablet Count",
                field: "tabletCount",
                type: "number",
                visible: true,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "IPad Count",
                field: "iPadCount",
                type: "number",
                visible: true,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Smart Phone Meshimer",
                field: "smartPhoneMeshimer",
                visible: true,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Dont Have Basic Phone",
                field: "dontHaveBasicPhone",
                type: "boolean",
                visible: true,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Basic Phone Meshimer",
                field: "basicPhoneMeshimer",
                visible: true,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Dont Have Smartphone",
                field: "dontHaveSmartphone",
                type: "boolean",
                visible: true,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Has Basic Phone Meshimer",
                field: "hasBasicPhoneMeshimer",
                type: "boolean",
                visible: true,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Is Home Computer Filtered",
                field: "isHomeComputerFiltered",
                type: "boolean",
                visible: true,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Is Home Computer Blocked",
                field: "isHomeComputerBlocked",
                type: "boolean",
                visible: true,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Dont Have Home Computer",
                field: "dontHaveHomeComputer",
                type: "boolean",
                visible: true,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Wife No Smartphone",
                field: "wifeNoSmartphone",
                type: "boolean",
                visible: true,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Wife No Qin Phone",
                field: "wifeNoQinPhone",
                type: "boolean",
                visible: true,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Home Computer Meshimer",
                field: "homeComputerMeshimer",
                visible: true,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Home Computer Filter Type",
                field: "homeComputerFilterType",
                visible: true,
                type: "number",
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Wife Name Of Workplace",
                field: "wifeNameOfWorkplace",
                visible: true,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Wife Work Address",
                field: "wifeWorkAddress",
                visible: true,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Wife Work Phone",
                field: "wifeWorkPhone",
                visible: true,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Wife Work Filter",
                field: "wifeWorkFilter",
                visible: true,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Wife Business Type",
                field: "wifeBusinessType",
                visible: true,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Wife Boss",
                field: "wifeBoss",
                visible: true,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Daughter Name Of Workplace",
                field: "daughterNameOfWorkplace",
                visible: true,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Daughter Work Address",
                field: "daughterWorkAddress",
                visible: true,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Daughter Work Phone",
                field: "daughterWorkPhone",
                visible: true,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Daughter Work Filter",
                field: "daughterWorkFilter",
                visible: true,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Daughter Boss",
                field: "daughterBoss",
                visible: true,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Note",
                field: "note",
                visible: true,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
        ],
    }),
    async created() {},
    beforeDestroy() {},
    methods: {
        onRowClicked(row) {
            this.clickedRow = JSON.parse(JSON.stringify(row));
            //this.note = row.note;
            //this.status = row.status ? row.status : "SUBMITTED";

            this.approveDialog = true;
        },
        allowChangingStatus() {
            const roles = Array.isArray(this.$store.state.authentication.roles)
                ? this.$store.state.authentication.roles
                : this.$store.state.authentication.roles
                ? this.$store.state.authentication.roles.split(",")
                : [];

            return roles.includes("VM Admin");
        },
        openApproveTemporaryDialog() {
            this.wifeNoSmartphone = this.clickedRow.wifeNoSmartphone;
            this.approveTemporaryDialog = true;
        },
        openDeleteFormDialog() {
            this.deleteFormDialog = true;
        },
        async deleteForm() {
            try {
                this.processing = true;

                await this.$http.post("api/vmForms/DeleteVmForms", [
                    this.clickedRow.id,
                ]);

                this.processing = false;
                this.deleteFormDialog = false;
                this.approveDialog = false;

                this.$refs.grid.reloadGrid();
            } catch (e) {
                this.processing = false;
            }
        },
        getRowProperties() {
            if (!this.clickedRow) return [];

            return Object.keys(
                except(
                    this.clickedRow,
                    "vgt_id",
                    "originalIndex",
                    "vgtExpended",
                    "signature",
                    "applicationDocument",
                ),
            )
                .map((key) => {
                    const column = this.columns
                        .filter((c) => !c.isIcon)
                        .find((c) => c.field == key);

                    if (!column) return { value: null };

                    const value =
                        ["date", "updatedAt"].includes(key) &&
                        this.clickedRow[key]
                            ? this.formatTime(this.clickedRow[key])
                            : this.clickedRow[key];

                    return {
                        name: column ? column.label : toTitleCase(key),
                        value: value,
                    };
                })
                .filter((p) => p.value);
        },
        downloadDocument() {
            window.open(this.clickedRow.documentURL);
        },
        formatTime(date) {
            return moment(date).format("MM/DD/YYYY h:mm:ss A");
        },
        async save() {
            // this.$notify({
            //             text: "Please Select the Caller ID",
            //             group: "notification",
            //             type: "error",
            //         });
            // if (!this.status) {
            //     return this.$notify({
            //         text: "Please Select Status",
            //         group: "notification",
            //         type: "error",
            //     });
            // }
            // if (this.status == "REJECTED" && !this.rejectedReason) {
            //     return this.$notify({
            //         text: "Reason Is Required",
            //         group: "notification",
            //         type: "error",
            //     });
            // }
            // if (this.status == "DELETED" && !this.deletedReason) {
            //     return this.$notify({
            //         text: "Reason Is Required",
            //         group: "notification",
            //         type: "error",
            //     });
            // }
            // try {
            //     this.processing = true;
            //     await this.$http.post("api/kollelForms/save", {
            //         status: this.status,
            //         rejectedReason:
            //             this.status == "REJECTED" ? this.rejectedReason : "",
            //         deletedReason:
            //             this.status == "DELETED" ? this.deletedReason : "",
            //         note: this.note,
            //         user: this.$store.state.authentication.user,
            //         accountID: this.clickedRow.accountID,
            //         id: this.clickedRow.id,
            //     });
            //     this.processing = false;
            //     this.approveDialog = false;
            //     this.$refs.grid.reloadGrid();
            // } catch (e) {
            //     this.processing = false;
            // }
        },
        editApplication() {
            this.$router.push(
                "/vm-form/" +
                    this.clickedRow.accountID +
                    (this.clickedRow.id ? "/" + this.clickedRow.id : ""),
            );
        },
        async quickSave() {
            if (!this.wifeNoSmartphone) {
                this.$notify({
                    text:
                        "Missing: מיר טוען באשטעטיגען אז די 'מאמע' פארמאגט נישט קיין סמארטפאון אפילו מיט א פילטער נאר א פשוטע בעיסק פאון",
                    group: "notification",
                    type: "error",
                });

                return;
            }

            try {
                this.clickedRow.wifeNoSmartphone = this.wifeNoSmartphone;

                this.processing = true;

                const response = await this.$http.post(
                    "api/vmForms/QuickSave",
                    this.clickedRow,
                );

                this.processing = false;
                this.approveDialog = false;
                this.approveTemporaryDialog = false;

                this.$notify({
                    text: "Account Has Been Temporary Approved",
                    group: "notification",
                    type: "success",
                });

                this.$refs.grid.reloadGrid();
            } catch (e) {
                console.log(e);
                this.processing = false;
            }
        },
    },
};
</script>
<style>
[v-cloak] {
    display: none;
}
.v-btn__content {
    color: unset;
}
</style>
